<div class="shepherd-progress">
  <a-progress-bar
    orientation="horizontal"
    [value]="progress()"
    max="100"
    thickness="10"
  />
</div>
